<template>
  <mdc-dialog v-model="isOpen"
              class="mdc_dialog_wider"
              :title="title"
              :accept="'user.close' | trans"
              @cancel="close"
              @accept="close">

    <loader class="table-loader" v-if="!dataSet"></loader>


    <table class="stage-results-table table table-sm" v-if="dataSet && dataSet.length">
      <thead class="thead-light">
      <tr>
        <th class="pl-3">
          {{'protocol.number_of_trials' | trans}}
        </th>
        <th class="text-center">
          {{'protocol.compliance_check' | trans}}
        </th>
        <th class="text-capitalize">{{'protocol.property' | trans}}</th>
      </tr>
      </thead>
      <tbody>

      <tr v-for="(taskData, indexTaskData) in dataSet">
        <td class="pl-3">
          {{taskData.sessionIndex}}.{{taskData.iterationIndex}}
        </td>
        <td class="text-center">
          {{taskData.title | trans}}
        </td>
        <td>
          <span v-for="task in taskData.stimuli" class="mr-2">{{task}}</span>
        </td>
      </tr>

      </tbody>

    </table>



  </mdc-dialog>
</template>

<script>

  import Loader from '../../loader/components/Loader';
  import lang from '../../../lang/translator';
  import axios from 'axios';
  import forEach from 'lodash/forEach';
  import maxBy from 'lodash/maxBy';
  import max from 'lodash/max';
  import moment from 'moment';

  import {
    BarChart,
    BarChartDataset,
  } from '../../../common/chart';

  export default {
    props: {
      'isVCD': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isChain': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isSimple': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isDtt': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isPecs': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isPecsWithoutDiscrimination': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isPecsWithDiscrimination': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isPecsWithItems': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isStageChain': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'version': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'stimulName': {
        type: String,
        default() {
          return '';
        },
      },
      'chartType': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'dataPoint': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'stimulId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'graphTitle': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'stageId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'categoryInfo': {
        type: [Array, Object],
        default() {
          return null;
        },
      }
    },
    data() {
      return {
        verticalLinePoint: [],
        apiUrl: '/protocols/assigned/',
        dataSet: null,
        valueMax: null,
      };
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },

      title: function () {

        let title = lang.get('protocol.categoryTitle') + ': ' + this.categoryInfo.title;

        return title;
      },

      scaleY: function () {

        let title = lang.get('report.reaction_count');

        return title;
      }
    },
    components: {Loader, BarChart},
    mounted() {
      this.showTable();
    },
    methods: {
      close() {
        this.$emit('close');
      },

      toLocaleDate: function (date) {
        return moment(date*1000).format('DD.MM.YYYY')
      },

      async showTable() {
        let apiUrl;
        let url, params;

        if(this.isPecsWithItems){
          apiUrl = this.apiUrl + 'pecs-features-with-items/';

          url = apiUrl + this.protocolId + '/detailed-session-mensuration/'+ this.stimulId;
          params = {
            date: this.dataPoint,
            type: this.chartType,
            version: this.version
          }
        }

        let response = await axios.get(url, {
          params: params
        });
        this.dataSet = response.data.data;
      },


    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/ChartPopupTable.vue